import React from 'react';
import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  Icon,
} from '@chakra-ui/react';
import { FiCheckCircle, FiAlertCircle } from 'react-icons/fi';

const providerLabel = (provider) => {
  if (provider === 'gmail') return 'Google';
  if (provider === 'outlook') return 'Microsoft';
  return 'Mailbox';
};

const OAuthTabCompleteCard = ({ provider, ok, accountEmail, onDismiss }) => {
  const name = providerLabel(provider);
  return (
    <Box
      position="fixed"
      inset={0}
      zIndex={1400}
      bg="rgba(0,0,0,0.72)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={4}
    >
      <Box
        maxW="md"
        w="full"
        bg="#0a0a0a"
        border="1px solid rgba(255,255,255,0.12)"
        borderRadius="xl"
        p={8}
        textAlign="center"
      >
        <VStack spacing={4}>
          <Icon
            as={ok ? FiCheckCircle : FiAlertCircle}
            boxSize={12}
            color={ok ? '#4ade80' : '#f87171'}
          />
          <Heading size="md" color="#fafafa">
            {ok ? `${name} sign-in complete` : `${name} sign-in failed`}
          </Heading>
          {accountEmail && (
            <Text fontSize="sm" fontFamily="mono" color="#a3a3a3">
              {accountEmail}
            </Text>
          )}
          {ok ? (
            <Text fontSize="sm" color="#a3a3a3" lineHeight="tall">
              Your other GillyReach tab has been updated. You can close this tab, or stay here if you
              prefer.
            </Text>
          ) : (
            <Text fontSize="sm" color="#a3a3a3" lineHeight="tall">
              Go back to Outbound setup or Integrations and try Connect OAuth again.
            </Text>
          )}
          <VStack w="full" spacing={2} pt={2}>
            {ok && (
              <Button
                w="full"
                bg="#fafafa"
                color="#0a0a0a"
                borderRadius="full"
                onClick={() => {
                  onDismiss?.();
                  window.close();
                }}
              >
                Close this tab
              </Button>
            )}
            <Button
              w="full"
              variant="outline"
              borderColor="rgba(255,255,255,0.2)"
              color="#fafafa"
              borderRadius="full"
              onClick={onDismiss}
            >
              {ok ? 'Stay on this page' : 'Dismiss'}
            </Button>
          </VStack>
        </VStack>
      </Box>
    </Box>
  );
};

export default OAuthTabCompleteCard;
